import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from "react-query";
import { deleteReminder } from "@/services/tasks";
import { useSelectedPatientStore } from "@/stores/selected-patient";

/** Mutation hook for deleting a patient reminder. Removes it from the local store on success. */
export function useDeleteReminder(patientUid) {
  return useMutation(function (reminderId) {
    if (!patientUid) throw new Error("patientUid is required");
    return deleteReminder(patientUid, reminderId);
  }, {
    onSuccess: function onSuccess(_data, reminderId) {
      var _selectedPatient$remi;
      var _useSelectedPatientSt = useSelectedPatientStore.getState(),
        selectedPatient = _useSelectedPatientSt.selectedPatient,
        setSelectedPatient = _useSelectedPatientSt.setSelectedPatient;
      if (!selectedPatient) return;
      var updatedReminders = ((_selectedPatient$remi = selectedPatient.reminders) !== null && _selectedPatient$remi !== void 0 ? _selectedPatient$remi : []).filter(function (r) {
        return r.id !== reminderId;
      });
      setSelectedPatient(_objectSpread(_objectSpread({}, selectedPatient), {}, {
        reminders: updatedReminders
      }));
    }
  });
}